import { AnchorLink } from 'gatsby-plugin-anchor-links'
import styled from 'styled-components'

const Wrapper = styled.div`
    @media ${(props) => props.theme.query.min.tablet} {
        padding-left: 30px;
        border-left: 0.5px solid ${(props) => props.theme.color.g300};
    }
`

const List = styled.ol`
    list-style-type: none;
`

const ListItem = styled.li`
    border-bottom: 0.5px solid ${(props) => props.theme.color.g300};
    display: block;
    padding: 15px 0px;

    &:last-child {
        border-bottom: none;
    }
`

const Title = styled.div`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
    text-transform: uppercase;
`

const Link = styled(AnchorLink)<{ $selected: boolean }>`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    text-decoration: none;
    display: flex;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.$selected && `color: ${props.theme.color.p500};`}

        &:hover {
            color: ${(props) => props.theme.color.p500};
        }
    }

    span {
        display: block;
        margin-left: 10px;
    }
`

const SubLink = styled(AnchorLink)`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    text-decoration: none;
    display: block;
    padding-left: 22px;
    margin-top: 10px;

    &:hover {
        color: ${(props) => props.theme.color.p500};
    }
`

export { Link, List, ListItem, SubLink, Title, Wrapper }
